module.exports = __webpack_public_path__ + "img/img71.fd0882da.svg";